/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Paper, Typography ,useTheme} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import VehiclesTable from './Components/Tables/VehiclesTable';
import MegaMenu from './Components/searchOptionComponents/DropdownMenu';
import { useDispatch, useSelector } from 'react-redux';
import { initialForm } from '../../actions/formAction';
import Loader from '../../components/Loader';
import { t } from 'i18next';
import { downloadExcel, getFetchData } from '../../actions/fetchDataAction';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetState as resetInitialState } from '../../slices/formInitialSlice';
import { resetState } from '../../slices/countSlice';
import AnimatedNumbers from "react-animated-numbers";
import Progress from '../../components/Loader/Progress ';
import CountVehicleView from '../Client/CountVehicleView';
import { getCount } from '../../actions/getCountAction';
import AddNewVehicleModal from '../AddNewVehicles/components/AddNewVehicleModal';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const Vehicles = () => {


    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const dataGridRef = useRef(null);
    const dataGridPaperRef = useRef(null);
    const formReducer = useSelector((state) => state.form);
    const vehicleCountReducer = useSelector((state) => state.fetchCount);
    const searchParams = new URLSearchParams(location.search);
    const [anchor] = useState(null);
    const [openAddVehicleModal, setOpenAddVehicleModal] = useState(false);
  const theme = useTheme();

    const fetchData = useSelector((state) => state.fetchData);
    const { accountType ,loading,isSuperUser,isShippingStaff,isWarehouseStaff, isAdminUser } = useSelector((state) => state.user)

      



    useEffect(() => {
        dispatch(initialForm())

        dispatch(getCount({ mode: "vehicle" }))


        return () => {

            dispatch(resetInitialState())
            dispatch(resetState())

        }

    }, [dispatch])


    const handleCloseAddVehicleModal = () => setOpenAddVehicleModal(false);

    const handleAddVehicle = () => {
        if (accountType !== 'client') {
            setOpenAddVehicleModal(true);
        } else {
            navigate('/VehicleaddEdit', { state: { inTransit: true } });
        }
    };






    useEffect(() => {



        dispatch(getFetchData({ query: searchParams.toString() }))


    }, [searchParams.get("PageSize"), searchParams.get("PageNumber"), searchParams.get("SortOrder"), searchParams.get("SortBy"), searchParams.get("MixSearch")])




    const handlingFetchData = () => {

        dispatch(getFetchData({ query: searchParams.toString() }))
        if (dataGridPaperRef.current) {
            dataGridPaperRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }


    }


    const handleCardClick = (name, id) => {
        // Get the current query parameters
        const searchParams = new URLSearchParams(location.search);
        const pageSize = searchParams.get('PageSize') || null;

        // Set the 'name' parameter to the given id
        if (name === 'Status') {
            searchParams.set('Status', id);
            if (pageSize === null) {
                navigate(`/vehicles?Status=${id}&PageSize=5`)
            } else {
                navigate(`/vehicles?Status=${id}`)
            }

        } else {
            if (pageSize === null) {
                navigate(`/vehicles?SearchOption=${id}&PageSize=5`)
            } else {
                navigate(`/vehicles?SearchOption=${id}`)
            }

        }


        if (dataGridPaperRef.current) {
            dataGridPaperRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }

    };




    if (formReducer.loading === 'pending' || formReducer.loading === 'idle' || vehicleCountReducer.loading === 'pending' || vehicleCountReducer.loading === 'idle') {
        return <Loader />
    }




    return (
        <Box sx={{ width: '100%', bgcolor: '#F7F8FA', minHeight: '100vh', p: { xs: 0, md: 2 } }}>

            {/* عنوان لوحة التحكم */}
            <Box sx={{ display: 'flex', justifyContent: "space-between", gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
                    <TimeToLeaveIcon sx={{ color: '#0B3C5D', fontSize: 36 }} />
                    <Typography variant="h4" sx={{ color: '#0B3C5D', fontWeight: 800, letterSpacing: 1 }}>
                        {t('Vehicles')}
                    </Typography>

                </Box>


            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'end', justifyContent: 'end', mb: 3}}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ borderRadius: 2, fontWeight: 700, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    startIcon={
                       <AddCircleOutlineIcon sx={{ color: theme.palette.secondary.main, fontSize: 24,  bgcolor: theme.palette.background.paper, borderRadius: '50%' }} />
                    }
                    onClick={handleAddVehicle}
                >
                    {t('Add Vehicle')}
                </Button>
                
            </Box>

            </Box>

            {/* إحصائيات المركبات */}
            <Paper
                sx={{
                    p: { xs: 1, md: 3 },
                    minHeight: 180,
                    flexGrow: 1,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)',
                    borderRadius: 4,
                    boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                    border: '1px solid #e9ecef',
                    mb: 3,
                }}
                anchorEl={anchor}
            >
                {vehicleCountReducer.loading === 'pending' || vehicleCountReducer.loading === 'idle' ? <Progress /> :
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                mt: 2,
                                justifyContent: 'flex-start',
                                flexWrap: 'nowrap',
                                gap: 3,
                                overflowX: 'auto',
                                overflowY: 'hidden',
                                pb: 1,
                                px: 0.5,
                                scrollbarWidth: 'thin',
                                '&::-webkit-scrollbar': {
                                    height: 8,
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c8d0d8',
                                    borderRadius: 8,
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: '#eef2f5',
                                    borderRadius: 8,
                                },
                            }}
                        >
                            {vehicleCountReducer.Object?.map((item, index) => {
                                // ألوان الدائرة والخط حسب الفهرس
                                const circleColor = ['#0B3C5D', '#D9B310', '#1A5F8C', '#A98A0C', '#F3D351', '#051E30'][index % 6];
                                const textColor = (index % 6 === 0 || index % 6 === 2 || index % 6 === 5) ? '#fff' : '#0B3C5D';


                                if (item?.name?.toUpperCase() === 'Total'.toUpperCase()) {

                                    return (<></>)
                                }

                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: 130,
                                            height: 160,
                                            flex: '0 0 130px',
                                            borderRadius: 4,
                                            background: '#fff',
                                            boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.08)',
                                            border: '1px solid #e9ecef',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            transition: 'transform 0.18s, box-shadow 0.18s',
                                            '&:hover': {
                                                transform: 'scale(1.06)',
                                                boxShadow: '0 8px 24px 0 rgba(11, 60, 93, 0.16)',
                                            },
                                            cursor: 'pointer',
                                            p: 0,
                                        }}
                                        onClick={() => handleCardClick(item.type, item.id)}
                                    >
                                        {/* دائرة رقم الإحصائية */}
                                        <Box sx={{
                                            width: 68,
                                            height: 68,
                                            borderRadius: '50%',
                                            background: `linear-gradient(135deg, ${circleColor} 60%, #fff 100%)`,
                                            boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mt: 2,
                                            mb: 1.5,
                                        }}>
                                            <Typography variant='h4' sx={{ color: textColor, fontWeight: 800, fontSize: 30, textShadow: textColor === '#fff' ? '0 1px 4px #0B3C5D55' : 'none' }}>
                                                <AnimatedNumbers
                                                    animateToNumber={item.count}
                                                    fontStyle={{ fontSize: 30 }}
                                                    configs={(number, index) => {
                                                        return { mass: 1, tension: 230 * (index + 1), friction: 50 };
                                                    }}
                                                />
                                            </Typography>
                                        </Box>
                                        {/* اسم الإحصائية */}
                                        <Typography sx={{ color: '#0B3C5D', fontWeight: 700, fontSize: 16, textAlign: 'center', px: 1, mb: 1 }}>{item.name}</Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                }
            </Paper>


            {/* خيارات البحث */}
            <Paper
                ref={dataGridPaperRef}
                sx={{
                    p: { xs: 1, md: 3 },
                    minHeight: 200,
                    flexGrow: 1,
                    mt: 3,
                    background: '#fff',
                    borderRadius: 4,
                    boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                    border: '1px solid #e9ecef',
                }}
            >
                {/* خيارات البحث أعلى الورقة */}
                <Box sx={{ mb: 2, width: '100%' }}>
                    <MegaMenu onFetchData={handlingFetchData} />
                </Box>
                {/* عداد المركبات وزر التصدير */}
                <Box sx={{ mb: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row-reverse' }, justifyContent: { xs: 'center', sm: 'space-between' }, alignItems: 'center', gap: 2, width: '100%' }}>
                    <CountVehicleView animate={false} count={fetchData?.Object?.totalElements} />
                    {fetchData.excelObject?.loading === 'pending' ? (
                        <Progress Msg='Generate As Excel' />
                    ) : (
                        <Button variant='b1' onClick={() => dispatch(downloadExcel({ query: searchParams.toString() }))} sx={{ minWidth: 160, borderRadius: 2, fontWeight: 700 }}>
                            {t('Generate As Excel')}
                        </Button>
                    )}
                </Box>
                {/* جدول المركبات */}
                {fetchData.loading === 'pending' ? <Progress Msg='Loading ...' /> :
                    <VehiclesTable isClient={accountType === "client"} isAdminUser={isAdminUser} isWarehouseStaff={isWarehouseStaff} isSuperUser={isSuperUser} isShippingStaff={isShippingStaff} handlingFetchData={handlingFetchData} ref={dataGridRef} data={{ content: [] }} />
                }
            </Paper>

            {!loading && <AddNewVehicleModal isOpen={openAddVehicleModal} onClose={handleCloseAddVehicleModal} />}
            
        </Box>
    )
}

export default Vehicles;
